import gql from 'graphql-tag';

import { eventTriggerSettingFragment } from './fragment';

export const getEventTriggerSettings = gql`
  query eventTriggerSettings($filters: EventTriggerSettingFiltersInput) {
    eventTriggerSettings(filters: $filters) {
      ...eventTriggerSettingParts
    }
  }
  ${eventTriggerSettingFragment}
`;

export const getEventTriggerSetting = gql`
  query eventTriggerSetting($id: ID!) {
    eventTriggerSetting(id: $id) {
      ...eventTriggerSettingParts
    }
  }
  ${eventTriggerSettingFragment}
`;

export const eventTriggerSettingCreate = gql`
  mutation eventTriggerSettingCreate($input: EventTriggerSettingCreateInput!) {
    eventTriggerSettingCreate(input: $input) {
      ...eventTriggerSettingParts
    }
  }
  ${eventTriggerSettingFragment}
`;

export const eventTriggerSettingUpdate = gql`
  mutation eventTriggerSettingUpdate(
    $id: ID!
    $input: EventTriggerSettingUpdateInput!
  ) {
    eventTriggerSettingUpdate(id: $id, input: $input) {
      ...eventTriggerSettingParts
    }
  }
  ${eventTriggerSettingFragment}
`;

export const eventTriggerSettingDelete = gql`
  mutation eventTriggerSettingDelete($id: ID!) {
    eventTriggerSettingDelete(id: $id)
  }
`;

export {
  eventTriggerSettingFragment,
  openDoorAlertValueFragment,
} from './fragment';
